import React from 'react'
import ListPqr from './ListPqr';
import CuentaSelected from "../../helpers/CuentaSelected";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Tooltip from "@material-ui/core/Tooltip";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import CreateNewPqr from "./CreateNewPqr";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {withRouter} from 'react-router';

class Pqrs extends React.Component {

    PqrForm = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            account: {},
            dataPqrs: [],
            open: false,
        };

        this.getCodeAccount = this.getCodeAccount.bind(this);
        this.getPqrs = this.getPqrs.bind(this);

    }

    async componentDidMount() {
        this.setState({
            account: CuentaSelected.get()
        });
        this.getPqrs();
    }

    getCodeAccount = () => {
        const account = CuentaSelected.get()
        return account.cuentaCodigo;
    }

    getPqrs = async () => {
        const account = CuentaSelected.get()
        let params = {
            account: account.cuentaCodigo
        }
        const data = await Api.post(`${Env.UrlBackend}/get-list-pqr`, params);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({
            dataPqrs: data.data
        });
    }

    openDialog = () => {
        this.setState({
            open: true
        });
    }

    handleCloseDialog = (showConfirm = true) => {

        // Si muestra el confirm quiere decir que esta intentando cancelar la pqr
        if (showConfirm) {
            confirmAlert({
                customUI: ({onClose}) => {
                    return (
                        <div className='custom-ui'>
                            <h3>¿Desea cancelar la creación de la PQR?</h3>
                            <button onClick={onClose}>No</button>
                            <button className='custom-ui-btn-si'
                                onClick={() => {
                                    this.setState({
                                        open: false
                                    });
                                    this.PqrForm.current.initForm();
                                    onClose();
                                }}
                            >
                                Si
                            </button>
                        </div>
                    );
                }
            });
        } else { // Si no muestra el confirm quiere decir que la pqr se guardó
            this.setState({
                open: false
            });
        }
    }

    render() {

        return (
            <div className='container-form'>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'menu',
                            label: 'Menú'
                        }
                    ]}
                    actual='Listado de PQRS'
                />

                <div style={{textAlign: 'center', paddingLeft: '30px', paddingRight: '30px'}}>

                    <h2>Listado de PQRS</h2>

                    <table className='custom-table'>
                        <tbody>
                        <tr>
                            <th>Nro Cuenta</th>
                            <td>{this.state.account.cuentaCodigo}</td>
                            <th>Cliente</th>
                            <td>{this.state.account.cuentaCliente}</td>
                        </tr>
                        <tr>
                            <th>Dirección</th>
                            <td>{this.state.account.DIRECCION}</td>
                            <th>Factura</th>
                            <td>{this.state.account.cuentaFactura}</td>
                        </tr>
                        </tbody>
                    </table>

                    <ListPqr
                        data={this.state.dataPqrs}
                    />

                    <Tooltip title="Crear nueva PQR">
                        <Fab onClick={this.openDialog} color="primary" aria-label="add" className='float-button'>
                            <AddIcon/>
                        </Fab>
                    </Tooltip>

                    <CreateNewPqr
                        ref={this.PqrForm}
                        open={this.state.open}
                        onClose={this.handleCloseDialog}
                        codeAccount={this.state.account.cuentaCodigo}
                        getCodeAccount={this.getCodeAccount}
                        getPqrs={this.getPqrs}
                    />

                </div>
            </div>

        );
    }
}

export default withRouter(Pqrs)
